import { useEffect } from 'react';
import { useIsFocused } from '@react-navigation/native';
import { useAppSelector } from 'store/hooks';
import { selectIsLoggedIn } from 'reducers/selectors';
import { useNavigateToNextScreen } from 'login/hooks/useNavigateToNextScreen';
export const useNavigateIfAddressInLoginNav = () => {
    const isLoggedIn = useAppSelector(selectIsLoggedIn);
    const userAddresses = useAppSelector((store) => store.addressReducer.userAddresses);
    const isFocused = useIsFocused();
    const navigateToNextScreen = useNavigateToNextScreen();
    useEffect(() => {
        if (!isLoggedIn && isFocused) {
            if (userAddresses.length) {
                navigateToNextScreen();
            }
        }
    }, [isFocused, isLoggedIn, userAddresses.length]);
};
